// ============================================================
// documentSearchMemory.ts — the Document search box, remembered for Back and
// refresh. Per-tab session storage only: never in the URL (file names often have
// a client's name in them, and URLs reach the hosting logs), never sent anywhere,
// and cleared on sign-out (useCasevoStore clearAuth). Storage can be blocked, so
// every access is guarded and a failure just means nothing is remembered.
// ============================================================
const KEY = 'casevo_document_search'

export const readDocumentSearch = (): string => {
  try { return sessionStorage.getItem(KEY) ?? '' } catch { return '' }
}
export const writeDocumentSearch = (text: string): void => {
  try {
    if (text) sessionStorage.setItem(KEY, text)
    else sessionStorage.removeItem(KEY)
  } catch { /* not remembered */ }
}
export const clearDocumentSearch = (): void => writeDocumentSearch('')
